import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { ResetPasswordRequest } from '@/types/request/ResetPasswordRequest.ts';

const useResetPassword = () => {
  const client = supabaseClient;

  const mutationFn = async (request: ResetPasswordRequest) => {
    return resetPassword(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useResetPassword;

async function resetPassword(client: SupabaseClient, request: ResetPasswordRequest): Promise<void> {
  // Update password and remove forceResetPassword flag
  const { error } = await client.auth.updateUser({
    password: request.password,
    data: {
      forceResetPassword: false,
    }
  });

  if (error) throw new Error(error.message);

  // Get current user
  const { data: { user } } = await client.auth.getUser();
  
  if (user) {
    // Update is_verified in users table
    await client
      .from('users')
      .update({ is_verified: true })
      .eq('auth_id', user.id);
  }
}
